// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 7.3\"><path fill=\"#434343\" d=\"M7 7.2L.6.9l.7-.7L7 5.8 12.6.2l.7.7z\"/></svg>";
// Exports
export default code;